// Libraries
import React from 'react'
import PropTypes from 'prop-types'

export const IconDownload = ({ width, height, color, clickable, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 21.78 23.455"
      width={width}
      height={height}
      style={{ cursor: clickable ? 'pointer' : 'auto' }}
      {...props}
    >
      <g transform="translate(0 0)">
        <g transform="translate(0 15.079)">
          <g transform="translate(0)">
            <path
              fill={color}
              d="M38.008,307.2a.838.838,0,0,0-.838.838v5.026a.838.838,0,0,1-.838.838H19.579a.838.838,0,0,1-.838-.838v-5.026a.838.838,0,1,0-1.675,0v5.026a2.513,2.513,0,0,0,2.513,2.513H36.333a2.513,2.513,0,0,0,2.513-2.513v-5.026A.838.838,0,0,0,38.008,307.2Z"
              transform="translate(-17.066 -307.2)"
            />
          </g>
        </g>
        <g transform="translate(5.874 0)">
          <g transform="translate(0)">
            <path
              fill={color}
              d="M146.52,14.486a.838.838,0,0,0-1.164,0l-2.76,2.758V.838a.838.838,0,0,0-1.675,0V17.245l-2.759-2.759a.838.838,0,0,0-1.184,1.184l4.188,4.188a.838.838,0,0,0,1.185,0l0,0,4.188-4.188A.838.838,0,0,0,146.52,14.486Z"
              transform="translate(-136.742 0)"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

IconDownload.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  color: PropTypes.string,
  clickable: PropTypes.bool,
}

IconDownload.defaultProps = {
  width: '19px',
  height: '19px',
  color: '#5badfa',
  clickable: false,
}

export default IconDownload
